const TeamTermAllPeriodList = 
`query teamTermAllPeriodList($teamTermId: Int!){
  teamTermAllPeriodList(teamTermId: $teamTermId){
    teamTermPeriodId
    name
    desc
    noOfWeeks
    inSprint
    sequence
    startDate
    endDate
    dateRange
    teamTermEvents{
      teamTermEventId
      name
      scheduledDate
      actualDate
      desc
      attendanceRequired
      eventTypeId{
        eventTypeId
        name
      }
      eventType
      formatDate
    }
  }
}`;

module.exports = {
  TEAM_TERM_ALL_PERIODS_QUERY: TeamTermAllPeriodList,  
};
